import { useQueries } from '@tanstack/react-query';

import { fetchSpecialQualifyingStatus } from './storeSpecial.api';
import type {
  QualifyingStatusProduct,
  SpecialQualifyingStatus,
} from './storeSpecial.types';

const QUALIFYING_STATUS_BASE_KEY = 'qualifyingStatus';

interface UseSpecialQualifyingStatusesProps {
  cartProducts: QualifyingStatusProduct[];
  cartUuid: string;
  specials: Array<{ id: number; special_type: string }>;
  storeId: string | number;
}

export const useSpecialQualifyingStatuses = ({
  cartProducts,
  cartUuid,
  specials,
  storeId,
}: UseSpecialQualifyingStatusesProps): Record<
  number,
  SpecialQualifyingStatus
> => {
  const nonProductSpecials = specials.filter(
    (s) => s.special_type !== 'product'
  );

  const enabled = !!cartUuid && !!storeId;

  const results = useQueries({
    queries: enabled
      ? nonProductSpecials.map((special) => ({
          queryKey: [
            QUALIFYING_STATUS_BASE_KEY,
            'stores',
            'specials',
            String(storeId),
            String(special.id),
            JSON.stringify(cartProducts),
            String(cartUuid),
          ],
          queryFn: () =>
            fetchSpecialQualifyingStatus({
              cartUuid,
              specialId: special.id,
              storeId,
            }),
        }))
      : [],
  });

  const statuses: Record<number, SpecialQualifyingStatus> = {};
  results.forEach((result, index) => {
    if (result.data) {
      statuses[nonProductSpecials[index].id] = result.data;
    }
  });

  return statuses;
};
